"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var layout_1 = require("../../layout");
var SidebarBody_1 = __importDefault(require("./SidebarBody"));
var SidebarContext_1 = require("./SidebarContext");
var SidebarHeader_1 = __importDefault(require("./SidebarHeader"));
var SidebarItem_1 = __importDefault(require("./SidebarItem"));
var SidebarLayout_1 = __importDefault(require("./SidebarLayout"));
var hooks_1 = require("../../../hooks");
var variables_1 = require("../../../style/variables");
var styles = {
    container: function (maxWidth, zIndex) { return react_1.css({
        display: 'inline-flex',
        width: 52,
        height: '100%',
        color: 'white',
        transition: 'width 300ms ease-in-out',
        overflowX: 'hidden',
        backgroundColor: "var(" + variables_1.RootColor.Gray.DARK_4 + ")",
        boxShadow: "var(" + variables_1.Shadow.md + ")",
        '&:hover': {
            width: maxWidth,
        },
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        zIndex: zIndex,
    }); },
};
var Sidebar = function (_a) {
    var children = _a.children, defaultExpanded = _a.expanded, onExpandedChange = _a.onExpandedChange, _b = _a.maxWidth, maxWidth = _b === void 0 ? 311 : _b, _c = _a.zIndex, zIndex = _c === void 0 ? 2 : _c;
    var _d = hooks_1.useControlledState({
        defaultValue: false,
        value: defaultExpanded,
        onChange: onExpandedChange,
    }), expanded = _d[0], setExpanded = _d[1];
    return (react_1.jsx(SidebarContext_1.SidebarContext.Provider, { value: {
            isExpanded: expanded,
        } },
        react_1.jsx(layout_1.Flex, { css: styles.container(maxWidth, zIndex), direction: "column", gap: 16, onMouseEnter: function () { return setExpanded(true); }, onMouseLeave: function () { return setExpanded(false); } }, children)));
};
Sidebar.Header = SidebarHeader_1.default;
Sidebar.Body = SidebarBody_1.default;
Sidebar.Item = SidebarItem_1.default;
Sidebar.Layout = SidebarLayout_1.default;
exports.default = Sidebar;
